import type { Category } from "@/types/article";

export const categories: Category[] = [
  {
    slug: "styling",
    name: "黑丝搭配",
    description: "从街头到晚宴，解锁黑丝丝袜的百变搭配灵感。",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photo%20of%20a%20stylish%20woman%20in%20black%20sheer%20tights%20with%20a%20chic%20outfit%20posed%20against%20a%20dark%20moody%20backdrop%20with%20soft%20directional%20lighting%20and%20refined%20neutral%20tones&width=1000&height=1200&seq=hei-cat-01&orientation=portrait",
    count: 0,
  },
  {
    slug: "tips",
    name: "丝袜穿搭技巧",
    description: "厚度选择、显腿技巧、保养收纳，实用干货一网打尽。",
    cover: "https://readdy.ai/api/search-image?query=Clean%20editorial%20still%20life%20of%20neatly%20folded%20black%20tights%20with%20fashion%20accessories%20on%20a%20light%20neutral%20surface%20with%20soft%20shadow%20and%20minimal%20composition&width=1000&height=1200&seq=hei-cat-02&orientation=portrait",
    count: 0,
  },
  {
    slug: "news",
    name: "潮流资讯",
    description: "秀场动态、流行趋势与明星街拍，第一时间掌握风向。",
    cover: "https://readdy.ai/api/search-image?query=Fashion%20week%20editorial%20photo%20of%20models%20in%20black%20tights%20on%20a%20minimal%20spotlit%20runway%20with%20dramatic%20shadows%20and%20high%20fashion%20mood&width=1000&height=1200&seq=hei-cat-03&orientation=portrait",
    count: 0,
  },
];

export const styleOptions = [
  { value: "street", label: "街头" },
  { value: "work", label: "职场" },
  { value: "dinner", label: "晚宴" },
  { value: "other", label: "休闲" },
];

export const colorOptions = [
  { value: "black", label: "黑" },
  { value: "nude", label: "肤色" },
  { value: "other", label: "别色" },
];

export const seasonOptions = [
  { value: "spring", label: "春" },
  { value: "summer", label: "夏" },
  { value: "autumn", label: "秋" },
  { value: "winter", label: "冬" },
];

export const sortOptions = [
  { value: "date", label: "最新发布" },
  { value: "popular", label: "最热" },
];